import React, { useState } from 'react';

import idGeneratorAtor from 'src/util/idGeneratorAtor';
import FileUpload from './FileUpload';

const idGenerator = idGeneratorAtor('uploadIcon');

export interface UploadIconProps {
    testid?: string;
    accept?: string;
    className?: string;
    children?: React.ReactNode;
    multiple?: boolean;
    onUpload: React.ChangeEventHandler<HTMLInputElement>;
    onGenerate?: () => void;
}

const UploadIcon: React.FC<UploadIconProps> = (props) => {
    const { children, onUpload, className, multiple, testid, accept = 'image/png, image/jpeg, image/bmp' } = props;
    const [uniqueId] = useState(() => idGenerator().replace(' ', ''));

    return (
        <button className={`upload-icon${className ? ` ${className}` : ''}`}>
            <label htmlFor={uniqueId} className='upload-icon__label' onClick={(e) => e.stopPropagation()}>
                {children || <img className='iconLg' src='https://static.ux.cimpress.io/assets/icons/add-2-l.svg' />}
            </label>
            <FileUpload
                id={uniqueId}
                testid={testid}
                className='hidden-input'
                onChange={onUpload}
                onClick={(e) => e.stopPropagation()}
                accept={accept}
                multiple={multiple}
            />
        </button>
    );
};

export default UploadIcon;
